import api from '../../../utils/api';

export const birthdayService = {
    /**
     * Send a birthday wish to a colleague
     * @param {number} receiverId 
     * @param {string} message 
     */
    sendWish: async (receiverId, message = "Happy Birthday!") => {
        try {
            const response = await api.post('/birthdays/wish', {
                receiverId,
                message
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || error.message || 'Failed to send wish');
        }
    },

    /**
     * Get wishes received by the logged-in user today
     */
    getReceivedWishes: async () => {
        try {
            const response = await api.get('/birthdays/wishes/received');
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || error.message || 'Failed to load wishes');
        }
    }
};
